import {
  ChangeEvent,
  FunctionComponent,
  useEffect,
  useRef,
  useState,
} from "react";
import { SingleValue } from "react-select";
import { useCart } from "../../context/CartContext";

import { Slide } from "react-slideshow-image";
import "./styles.scss";
import TableModal from "../TableModal";
import VariantsAndCustomModal from "../VariantsAndCustomModal";
import AddedVariantsMobile from "../AddedVariantsMobile";
import { Icon } from "../Icon";
import "react-slideshow-image/dist/styles.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CartModal from "../CartModal";
import classNames from "classnames";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

import type { BodyScrollOptions } from "body-scroll-lock";

type Props = {
  product: Product;
  variations: Variation[];
  manufacturingCost: ManufacturingCost[];
  isAuth: boolean;
};

const ItemDetailMobile: FunctionComponent<Props> = ({
  product,
  variations,
  manufacturingCost,
  isAuth,
}) => {
  const bodyRef = useRef<null | HTMLDivElement>(null);
  const precartData = useRef<null | HTMLDivElement>(null);
  const tableRef = useRef<null | HTMLDivElement>(null);
  const [tableRefPosition, setTableRefPosition] = useState<number>(0);
  const { addToCart, isLoading, setLastProductAdded } = useCart();
  const [showCartModal, setShowCartModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"variants" | "custom" | null>(
    null
  );
  // REFACTOR THIS IN THE FUTURE, this should be a
  // new PreCartContext that's implemented at the item level instead of the whole app level, there's too much logic on this component

  // everything related to table should be a different component, keep it inside of item detail container but it's a static part
  // of the product view, so why keep it rerendering when we change te rest of the things? also helps with clear coding
  const [images, setImages] = useState<string[]>();
  const navigate = useNavigate();
  const [table, setTable] = useState<string[][]>([]);
  const [gauges, setGauges] = useState<string[]>([]);
  const [lengths, setLengths] = useState<string[]>([]);
  const [colors, setColors] = useState<string[]>([]);
  const [exist, setExist] = useState<boolean>(false);
  const [incomplete, setIncomplete] = useState<boolean>(false);
  const [isLoginRequired, setIsLoginRequired] = useState<boolean>(false);
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const [variation, setVariation] = useState<Variation>({
    weight: "",
    length: "",
    color: "",
    gauge: "",
    productId: product._id || "",
    manufacturingCostId: "",
  });
  const [preCart, setPreCart] = useState<CartProduct[]>([]);

  const [addOneProduct, setaddOneProduct] = useState<CartProduct>({
    ...product,
    weight: "",
    length: "",
    color: "",
    gauge: "",
    productId: product._id || "",
    manufacturingCostId: "",
    quantity: 1,
    manufacturValue: 0,
  });
  const [showTable, setShowTable] = useState<boolean>(false);
  const [showVariantsAndCustomModal, setShowVariantsAndCustomModal] =
    useState<boolean>(false);
  const [showAddedVariants, setShowAddedVariants] = useState<boolean>(false);

  const [customization, setCustomization] = useState(variation?.customization);

  useEffect(() => {
    // never call aux to a variable
    // also, if we need all this info in 1, we can create a new endpoint for this.
    let aux: CartProduct = {
      ...product,
      ...variation,
      quantity: addOneProduct.quantity,
      manufacturingCostId:
        variations.find(
          (el) =>
            el.color == variation.color &&
            el.gauge == variation.gauge &&
            el.length == variation.length
        )?.manufacturingCostId || "",
      weight:
        variations.find(
          (el) =>
            el.color == variation.color &&
            el.gauge == variation.gauge &&
            el.length == variation.length
        )?.weight || "",
      manufacturValue:
        manufacturingCost.find(
          (el) =>
            el._id ==
              variations.find(
                (el) =>
                  el.color == variation.color &&
                  el.gauge == variation.gauge &&
                  el.length == variation.length
              )?.manufacturingCostId || ""
        )?.value || 0,
      _id:
        variations.find(
          (el) =>
            el.color == variation.color &&
            el.gauge == variation.gauge &&
            el.length == variation.length
        )?._id || "",
    };
    setaddOneProduct(aux);
  }, [variation]);

  useEffect(() => {
    const options: BodyScrollOptions = {
      reserveScrollBarGap: true,
    };
    bodyRef.current &&
      (showVariantsAndCustomModal || showTable
        ? disableBodyScroll(bodyRef.current, options)
        : clearAllBodyScrollLocks());
  }, [showVariantsAndCustomModal, showTable]);

  useEffect(() => {
    // this should be on new functions or helpers to construct this.
    // as it is, this becomes untesteable
    resetVariation();
    let weights: string[][] = [];
    let gaugesAux: string[] = [];
    let lengthAux: string[] = [];
    let colorsAux: string[] = [];
    variations.forEach((el) => {
      !gaugesAux.some((some) => some == el.gauge) && gaugesAux.push(el.gauge);
      !lengthAux.some((some) => some == el.length) && lengthAux.push(el.length);
      !colorsAux.some((some) => some.toLowerCase() == el.color) &&
        colorsAux.push(el.color[0].toUpperCase() + el.color.slice(1));
    });

    setGauges(gaugesAux);
    setLengths(lengthAux);
    setColors(colorsAux);
    for (let j = 0; j < gaugesAux.length; j++) {
      let arrayAuxiliar: string[] = [];
      arrayAuxiliar.push(gaugesAux[j]);
      for (let i = 0; i < lengthAux.length; i++) {
        let found = variations.find(
          (el) => el.gauge == gaugesAux[j] && el.length == lengthAux[i]
        );
        found?.weight
          ? arrayAuxiliar.push(found?.weight)
          : arrayAuxiliar.push("X");
      }
      weights.push(arrayAuxiliar);

      setTable(weights);
    }

    setImages(product.thumbnailUrl.split("|"));
  }, []);

  const sumItem = (e: any) => {
    e.preventDefault();

    setaddOneProduct({
      ...addOneProduct,
      quantity: addOneProduct.quantity + 1,
    });
  };
  const restItem = (e: any) => {
    e.preventDefault();
    addOneProduct.quantity - 1 > 0 &&
      setaddOneProduct({
        ...addOneProduct,
        quantity: addOneProduct.quantity - 1,
      });
  };

  const handleChange = (e: any) => {
    setExist(false);
    setIncomplete(false);
    if (e.currentTarget.name !== "customization") {
      setVariation({
        ...variation,
        [e.currentTarget.name]: e.currentTarget.value,
      });
    }
  };

  const handleSelectChange = (
    selectedOption: SingleValue<{ value: string; label: string }>,
    e: any
  ) => {
    setExist(false);
    setIncomplete(false);
    setVariation({
      ...variation,
      [e.name]:
        e.name == "color"
          ? selectedOption?.value.toLowerCase()
          : selectedOption?.value,
    });
  };

  const handleCreateCustomization = (newCustomization: string | undefined) => {
    setVariation({
      ...variation,
      customization: newCustomization,
    });
    if (preCart.length > 0) {
      const customizationAdded = preCart.map((x, i) => {
        return { ...x, customization: newCustomization };
      });
      setPreCart(customizationAdded);
      if ((newCustomization?.length ?? 0) > 0) setShowCustomAlert(false);
    }
  };

  const handleNativeSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const name = e.target.name;
    const selectedValue = e.target.value;
    setExist(false);
    setIncomplete(false);
    setVariation({
      ...variation,
      [name]: name === "color" ? selectedValue.toLowerCase() : selectedValue,
    });
  };

  const manageCart = () => {
    if (addOneProduct.isCustom) {
      if (!customization || customization?.length === 0) {
        return setShowCustomAlert(true);
      }
    }
    setaddOneProduct({
      ...product,
      _id: "",
      weight: "",
      length: "",
      color: "",
      gauge: "",
      productId: product._id || "",
      manufacturingCostId: "",
      quantity: 1,
      manufacturValue: 0,
    });
    resetVariation();

    setLastProductAdded({
      title: preCart[0]?.title ?? "",
      thumbnailUrl: preCart[0]?.thumbnailUrl ?? "",
      variations: preCart.length,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowCartModal(true);
    preCart.forEach((c, i) => {
      if (i === 0) {
        addToCart({
          variationId: c._id as string,
          quantity: c.quantity,
          customization: c.customization,
        });
      } else {
        addToCart({
          variationId: c._id as string,
          quantity: c.quantity,
        });
      }
    });

    setPreCart([]);
  };

  const removeItem = (id: string) => {
    setPreCart(preCart.filter((el) => el._id != id));
  };

  const imageEncoder = (value: string) => {
    const imageString = value.split("/").slice(3).join("/");
    return (
      "https://assets.rtabak.com.ar/" +
      encodeURIComponent(imageString).replace(
        /[!'()*]/g,
        (c) => "%" + c.charCodeAt(0).toString(16)
      )
    );
  };

  const addPreCart = () => {
    if (addOneProduct._id == "") {
      setIncomplete(true);
    } else {
      setIncomplete(false);
      if (preCart.some((el) => el._id == addOneProduct._id)) {
        setExist(true);
      } else {
        setExist(false);
        setPreCart([...preCart, addOneProduct]);
        setaddOneProduct({
          ...product,
          _id: "",
          weight: "",
          length: "",
          color: "",
          gauge: "",
          productId: product._id || "",
          manufacturingCostId: "",
          quantity: 1,
          manufacturValue: 0,
        });
        onClickVariants();
        resetVariation();
      }
    }
  };
  // container logic and presentational on the same component is not a good idea.

  let totalWeightPreCart = 0;
  let totalPriceCart = 0;

  preCart.forEach(function (item) {
    totalPriceCart += Number(item.manufacturValue) * item.quantity;
  });

  preCart.forEach(function (item) {
    totalWeightPreCart += Number(item.weight) * item.quantity;
  });

  const onClickTable = () => {
    showTable && clearAllBodyScrollLocks();
    setShowTable(!showTable);
    tableRef.current?.offsetTop &&
      setTableRefPosition(tableRef.current?.offsetTop);
  };

  const onClickVariants = () => {
    setModalType("variants");
    setShowVariantsAndCustomModal(!showVariantsAndCustomModal);
    showAddedVariants == false && setShowAddedVariants(!showAddedVariants);

    // precartData.current &&
    //   scrollTo({ top: precartData.current.offsetTop - 400 });
  };

  const onClickAddedVariants = () => {
    setShowAddedVariants(!showAddedVariants);
  };

  const resetVariation = () => {
    setVariation(
      variations.length === 1
        ? {
            weight: variations[0].weight,
            length: variations[0].length,
            color: variations[0].color,
            gauge: variations[0].gauge,
            productId: product._id || "",
            manufacturingCostId: variations[0].manufacturingCostId,
          }
        : {
            weight: "",
            length: "",
            color: product.material == "silver" ? "plata" : "",
            gauge: "",
            productId: product._id || "",
            manufacturingCostId: "",
          }
    );
  };

  return (
    <div
      ref={bodyRef}
      className={classNames(
        "itemDetailContainerModal",
        (showTable || showVariantsAndCustomModal) &&
          "itemDetailContainerModalOpen"
      )}
    >
      <ToastContainer
        autoClose={1500}
        position={"bottom-center"}
        closeButton={false}
        toastClassName={"toastItemDetail"}
      ></ToastContainer>
      {!showTable ? (
        <>
          {showCartModal && (
            <>
              <CartModal
                handleClose={() => {
                  clearAllBodyScrollLocks();
                  setShowCartModal(false);
                }}
                type={"productAdded"}
                productLoading={isLoading}
              />
            </>
          )}
          <section className="product_container_mobile">
            <header className="product_mobile_header">
              <div className="product_mobile_img_container">
                <Slide indicators={true} arrows={false} autoplay={false}>
                  {images &&
                    images.map((slideImage, index) => {
                      return (
                        <div key={index}>
                          <div
                            className="slider"
                            style={{
                              backgroundImage: `url(${imageEncoder(
                                slideImage
                              )})`,
                            }}
                          >
                            <p
                              className="product_mobile_back"
                              onClick={() => navigate(-1)}
                            >
                              <span>{"<"}</span>Volver
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </Slide>
              </div>
              <div className="product_mobile_data" ref={precartData}>
                {product.material == "gold" ? (
                  <p className="product_mobile_material product_gold">
                    Oro 18k
                  </p>
                ) : (
                  <p className="product_mobile_material product_silver">
                    Plata
                  </p>
                )}
                <div className="product_mobile_title" ref={tableRef}>
                  <h3>{product.title}</h3>
                  <button onClick={onClickTable}>TABLA</button>
                </div>
                {product.sku ? (
                  <p className="product_mobile_sku">{product.sku}</p>
                ) : null}
              </div>
            </header>
            {(!preCart || !preCart.length) && (
              <p className="product_mobile_select">
                Seleccioná color, hilo, largo y cantidad
              </p>
            )}
            {preCart && preCart.length > 0 && (
              <AddedVariantsMobile
                preCart={preCart}
                removeItem={removeItem}
                setShowAddedVariants={onClickAddedVariants}
                showAddedVariants={showAddedVariants}
              />
            )}
            {!preCart || !preCart.length ? (
              <button onClick={onClickVariants} className="product_mobile_add">
                Agregar variantes
              </button>
            ) : (
              <div className="product_mobile_buttons">
                <button
                  onClick={onClickVariants}
                  className="product_aggregate_mobile"
                >
                  Seguir agregando
                </button>
              </div>
            )}
            {(addOneProduct.isCustom ||
              addOneProduct.category.includes("isCustom")) && (
              <div className="customization_item_mobile">
                <span
                  title="Personalizar"
                  onClick={() => {
                    setModalType("custom");
                    setShowVariantsAndCustomModal(true);
                  }}
                >
                  <Icon
                    iconName="edit-icon-squared"
                    className="customization_item_icon"
                  />
                  <p>
                    {variation.customization == "" || !variation.customization
                      ? "Personalizar"
                      : "Personalizado"}
                  </p>
                </span>{" "}
                {showCustomAlert && (
                  <p
                    className="itemDetail_data_msg"
                    style={{ marginLeft: "4px" }}
                  >
                    Complete la personalización!
                  </p>
                )}
              </div>
            )}
            {preCart && preCart.length > 0 ? (
              <div className={"product_cart_container_mobile"}>
                <button
                  onClick={manageCart}
                  type="button"
                  className="product_cart_mobile"
                >
                  Agregar al carrito
                </button>
                <div className="product_cart_icon_mobile">
                  <Icon iconName="alert_icon" />
                  <p>Los pesos son aproximados</p>
                </div>
              </div>
            ) : null}
          </section>
          {showVariantsAndCustomModal ? (
            <VariantsAndCustomModal
              customization={customization}
              setCustomization={(value: string) => setCustomization(value)}
              modalType={modalType}
              variation={variation}
              addOneProduct={addOneProduct}
              handleChange={handleChange}
              handleNativeSelectChange={handleNativeSelectChange}
              colors={colors.sort()}
              lengths={lengths}
              gauges={gauges}
              restItem={restItem}
              sumItem={sumItem}
              addPreCart={addPreCart}
              handleSelectChange={handleSelectChange}
              closeModal={onClickVariants}
              exist={exist}
              incomplete={incomplete}
              handleCreateCustomization={handleCreateCustomization}
              isAuth={isAuth}
              setIsLoginRequired={setIsLoginRequired}
              isLoginRequired={isLoginRequired}
            />
          ) : null}
        </>
      ) : (
        <TableModal
          lengths={lengths}
          table={table}
          closeModal={onClickTable}
          product={product}
        />
      )}
    </div>
  );
};

export default ItemDetailMobile;
